export const PROJECT_VIEW_TABLE_COLUMNS = ['Id', 'Name', 'Major States', 'Reject State', 'User Group', 'Action'];
export const PROJECT_MAJOR_STATES = (['Edit', 'Review', 'MetaReview'] as const);